// ============================================================
// ParrySuccessChart - Parry DoS distribution bar chart, in amber.
// ============================================================
import type { ReactionProbability } from '../../engine/defenceProbability';
import ReactionDosChart from './ReactionDosChart';

export default function ParrySuccessChart({ data }: { data: ReactionProbability }) {
  return <ReactionDosChart data={data} colour="#f59e0b" />;
}
